export default __webpack_public_path__ + "static/media/Inovadores.93816477.svg";